import React, { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiClient from "../utils/config/apiClient";
import { data } from "jquery";
import { toast } from "sonner";

export default function NewPassword() {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");


 const localEmail = localStorage.getItem("localEmail")


 console.log(localEmail);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, 
    }));
  };

  const data ={
    "password":formData.password,
    "repassword":formData.confirmPassword,
    "email":localEmail
  }

const handleSubmit = async (e) => {
  e.preventDefault();
  if (formData.password !== formData.confirmPassword) {
    alert("Passwords do not match!");
    return;
  }
  try {
    await apiClient.post(`/public/portal?url=auth/patient/password/reset`, data , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    // console.log("Form submitted:", formData);
    toast.success("Password Updated successully")
    navigate("/pages/signin2");
  } catch (error) {
    console.error("Error resetting password:", error);
  }
};

  return (
    <div className="page-sign">
      <Card className="card-sign">
        <Card.Header>
          <Link to="/" className="header-logo mb-4">
            Deda
          </Link>
          <Card.Title>Reset Password</Card.Title>
          <Card.Text>Enter your new Password to continue.</Card.Text>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <div className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                onChange={handleChange}
                name="password"
                type="password"
                placeholder="Enter your password"
                value={formData.password}
                required
              />
            </div>
            <div className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                onChange={handleChange}
                name="confirmPassword"
                type="password" // Fixed from "text" to "password"
                placeholder="Confirm your password"
                value={formData.confirmPassword}
                required
              />
            </div>
            <Button variant="primary" className="btn-sign" type="submit">
              Submit
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}